import { styled } from '@mui/material/styles';
import { shouldForwardProp as muiShouldOverrideProp } from '@mui/system/createStyled';
import { textFieldClasses } from './textFieldClasses';
import Grid from '@mui/material/Grid';
import Typography from '../Typography/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MuiClearIcon from '@mui/icons-material/Close';

/** TODO: Update those colors once they are included in the palette */
const navigationColor = '#7A6E95';
const navigationHoverColor = '#4A396E';

export const TextFieldRoot = styled('span', {
  name: 'AFTextField',
  shouldForwardProp: prop => muiShouldOverrideProp(prop)
})(({ theme }) => {
  return {
    [`& .${textFieldClasses.textFieldLabel}`]: {
      display: 'block',
      marginLeft: theme.spacing(0.5)
    }
  };
});

export const Footer = styled(Grid, {
  shouldForwardProp: prop =>
    !['fullWidth', 'size', 'showCharCount'].includes(prop)
})(({ theme, showCharCount, fullWidth, size }) => ({
  minWidth: !showCharCount && !fullWidth && theme.sizes?.textField[size],
  width: showCharCount && !fullWidth && theme.sizes?.textField[size],
  flexWrap: 'nowrap',
  margin: theme.spacing(0.5, 0, 0.5, 0),
  padding: theme.spacing(0, 0.5, 0, 0.5)
}));

export const HelperMessage = styled(Typography, {
  shouldForwardProp: prop => prop !== 'error'
})(({ theme, error }) => ({
  fontSize: 12,
  color: error ? theme.palette.error.main : theme.palette.text.secondary
}));

export const CounterContainer = styled(Grid)(({ theme }) => ({
  alignSelf: 'flex-start',
  flexGrow: 100,
  marginLeft: theme.spacing(1)
}));

export const HelpIcon = styled(HelpOutlineIcon)(({ theme }) => ({
  color: navigationColor,
  marginLeft: theme.spacing(0.5),
  '&:hover': {
    color: navigationHoverColor
  }
}));

export const ClearIcon = styled(MuiClearIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.grey[900]
  }
}));
